import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import reducers from './reducers';
import PostsIndex from './components/posts_index';
import PostsNew from './components/posts_new';
import promise from 'redux-promise';
import PostShow from './components/posts_show';
import * as serviceWorker from "./serviceWorker";
import './style/style.css';

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <BrowserRouter>
    <div class="main-div">
      <Switch>
      <Route path="/crud-app/posts/new" component={PostsNew} />
      <Route path="/crud-app/posts/:id" component={PostShow} />
      <Route path="/crud-app" component={PostsIndex} />
      </Switch>
    </div>
    </BrowserRouter>
  </Provider>
  , document.getElementById("root"));
serviceWorker.unregister();

